var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52187 10.5892V16.8187H3.29236V10.5892H9.52187ZM10.3006 1.63428L14.5833 8.64247H6.01777L10.3006 1.63428ZM14.5833 10.1999C16.5301 10.1999 18.0874 11.7572 18.0874 13.7039C18.0874 15.6507 16.5301 17.208 14.5833 17.208C12.6366 17.208 11.0792 15.6507 11.0792 13.7039C11.0792 11.7572 12.6366 10.1999 14.5833 10.1999Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c1703f010302a3aaa07f5e8dd06313b7.svg";
export { ForwardRef as ReactComponent };